import dayjs from 'dayjs';

import { isBlockExpired } from './is-block-expired';

export const isBlockNotYetActive = (inceptionDate?: string | null) => {
  if (inceptionDate && dayjs().isBefore(inceptionDate, 'day')) {
    return true;
  }

  return false;
};

export const isBlockInactive = (inceptionDate?: string | null, expiryDate?: string | null) => {
  if (isBlockNotYetActive(inceptionDate)) {
    return true;
  }

  return isBlockExpired(expiryDate ?? undefined);
};
